import { screenHeight } from "./common/function/screenheight.es6";
import { gnav } from "./common/function/gnav.es6";
import { fixedshare } from "./common/function/fixedshare.es6";
import { ready } from "./common/function/ready.es6";

//common classes
import Modal from "./common/classes/modal.es6";
import ScrollFunc from "./common/classes/scrollfunc.es6";
import Movie from "./common/classes/movie.es6";


class Common {

    constructor(){
        this._init();
    }

    _init(){
        this.modal = new Modal();
        this.scrollFunc = new ScrollFunc();
        this.movie = new Movie();

        screenHeight();
        gnav();
        fixedshare();
        ready();
    }
}

const common = new Common();